import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerGoals: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const [{ goalsRequestHandler }, { goalSettingsRequestHandler }] = await Promise.all([import("./mocks/goalsRequestHandler.ts"), import("./mocks/goalSettingsRequestHandler.ts")]);

        runtime.registerRequestHandlers([goalsRequestHandler, goalSettingsRequestHandler]);
    }
};
